import { StatusBar } from "expo-status-bar";
import React from "react";
import { Platform, StyleSheet } from "react-native";
import GroupsList from "../../components/Accounts/Groups/List";
import ErrorBoundary from "../../components/ErrorBoundary";
import { View } from "../../components/Themed";

export default function GroupsScreen() {
  return (
    <View style={styles.container}>
      <ErrorBoundary>
        <GroupsList />
      </ErrorBoundary>
      <StatusBar style={Platform.OS === "ios" ? "light" : "auto"} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  accountsList: {
    width: "100%",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: "80%",
  },
});
